/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FirstInteractionFilterConfigColumn =
  (typeof FirstInteractionFilterConfigColumn)[keyof typeof FirstInteractionFilterConfigColumn];

export const FirstInteractionFilterConfigColumn = {
  first_interaction: 'first_interaction',
} as const;
